import React from "react";

/**
 * A simple component for copying a selected column's data to the clipboard.
 */
export default class ColumnCopier extends React.PureComponent {
    
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
            selectedColumn: 'enclosure_serial_no'
        };
        this.copyColumnData = this.copyColumnData.bind(this);
    }

    copyColumnData() {
        const { getColumnData } = this.props;
        const columnData = getColumnData(this.state.selectedColumn);

        if (columnData && columnData.length > 0) {
            const textToCopy = columnData.join(", ");
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    this.setState({ copied: true });
                    setTimeout(() => this.setState({ copied: false }), 2000);
                })
                .catch(err => console.error("Failed to copy text: ", err));
        }
    }

    render() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <p>Copy data from column:</p>
                <select
                    value={this.state.selectedColumn}
                    onChange={e => this.setState({ selectedColumn: e.target.value })}
                    style={{ padding: '5px', fontSize: '14px', marginTop: '5px' }}
                >
                    <option value="">Select a column</option>
                    {this.props.columns.map(column => (
                        <option key={column.accessor} value={column.accessor}>
                            {column.Header}
                        </option>
                    ))}
                </select>
            <button onClick={this.copyColumnData}>
                {this.state.copied ? "Copied!" : "Copy"}
            </button>
            </div>
        );
    }
}